import { Box, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { useMandatorContext } from "@bn/theming";
import { useMyself } from "@api/v1/hooks/useMyself";
import { Logo } from "@components/Logo";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const PlusTypography = styled(Box)`
  color: ${({ theme }) => theme.palette.common.black};
  background-color: ${({ theme }) => theme.palette.primary.light};
  font-weight: 600;
  font-size: 10px;
  padding: ${({ theme }) => `5px ${theme.spacing(2)} ${theme.spacing(1)}`};
  border-radius: ${({ theme }) => `${theme.shape.borderRadius}px`};
  display: flex;
  align-items: center;
  height: 24px;
`;

const ProTypography = styled(PlusTypography)`
  background-color: ${({ theme }) =>
    theme.palette.button.upgradeButton?.default};
  color: ${({ theme }) => theme.palette.button.upgradeButton?.textOnDefault};
`;

export interface AppSidebarHeaderSmallProps {
  onTestPremiumClick?: () => void;
  className?: string;
  onLogoClick?: () => void;
}

export const AppSidebarHeaderSmall = ({
  onTestPremiumClick,
  className,
  onLogoClick,
}: AppSidebarHeaderSmallProps) => {
  const { t } = useTranslation();
  const { data: myself } = useMyself();
  const { isAriva } = useMandatorContext();

  return (
    <Container className={className}>
      <Logo variant="sidebar" onClick={onLogoClick} />
      {/* Ariva moves Test Premium to the bottom of the sidebar. */}
      {myself?.isUserPro && <ProTypography>{t("common.pro")}</ProTypography>}
      {myself?.isUserPlus && (
        <PlusTypography>{t("common.plus")}</PlusTypography>
      )}
      {!isAriva && myself?.isUserFree && (
        <Button
          onClick={onTestPremiumClick}
          variant="primary"
          color="upgrade"
          size="small"
          sx={{
            height: "28px",
          }}
        >
          {t("sidebar.header.testPremium")}
        </Button>
      )}
    </Container>
  );
};
